<h2 class="default-dialog-header" mat-dialog-title>
	{{ data?.title }}
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form [formGroup]="accountEmailMapForm">
		<div fxLayout="row" class="m-t-1" fxLayoutGap="1rem">
			<div fxFlex>
				<mat-form-field class="full-width" *ngIf="!isLoadingUsersList">
					<mat-select
						formControlName="userId"
						placeholder="Select User"
						(selectionChange)="updateSelectedUser($event.value)"
					>
						<mat-option *ngFor="let user of accountUsers" [value]="user.id">
							{{ user.email }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-spinner *ngIf="isLoadingUsersList" [diameter]="30"></mat-spinner>
			</div>
			<div fxFlex>
				<mat-form-field class="full-width">
					<mat-select formControlName="state" placeholder="Select States" multiple>
						<mat-option *ngFor="let state of stateOptions" [value]="state.value">
							{{ state.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div fxLayout="row" class="m-t-1" fxLayoutGap="1rem">
			<div fxFlex>
				<div fxFlex>First Name:</div>
				<div fxFlex>{{ selectedUser?.firstName }}</div>
			</div>
			<div fxFlex>
				<div fxFlex>Last Name:</div>
				<div fxFlex>{{ selectedUser?.lastName }}</div>
			</div>
		</div>
	</form>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end">
		<span (click)="closeDialog(null)" class="link m-r-1">
			{{ data?.cancelButtonText }}
		</span>
		<button
			(click)="submitFormData()"
			*ngIf="!isRequestInProgress"
			[disabled]="accountEmailMapForm.invalid"
			color="primary"
			mat-raised-button
		>
			{{ data?.ConfirmButtonText }}
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
